import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import clientEnv from '@env';
// Import language resources
import enUS from '../locales/en-US.json';
import enGB from '../locales/en-GB.json';
const resources = {
    'en-US': {
        translation: enUS
    },
    'en-GB': {
        translation: enGB
    }
};
i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
    resources,
    fallbackLng: 'en-US',
    debug: clientEnv.NODE_ENV === 'development',
    interpolation: {
        escapeValue: false, // React already escapes values
    },
    detection: {
        // Order and from where user language should be detected
        order: ['localStorage', 'navigator', 'htmlTag'],
        // Keys or params to lookup language from
        lookupLocalStorage: 'i18nextLng',
        lookupFromPathIndex: 0,
        lookupFromSubdomainIndex: 0,
        // Cache user language on
        caches: ['localStorage'],
        excludeCacheFor: ['cimode'], // Languages to not persist (cookie, localStorage)
        // Optional expire and domain for set cookie
        cookieMinutes: 10,
        cookieDomain: 'myDomain',
        // Optional htmlTag with lang attribute, the default is:
        htmlTag: document.documentElement,
        // Optional set cookie options, reference:[MDN Set-Cookie docs](https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Set-Cookie)
        cookieOptions: { path: '/', sameSite: 'strict' }
    },
    react: {
        useSuspense: false
    }
});
export default i18n;
